import { CANCEL, CONFIRM } from 'mk/autogenerated/translations/FormPage.492fee47fb29a3b9f21b8716f4ade9d3'
import Btn, { BtnType } from 'mk2/components/Btn';
import { FormPageType } from 'mk2/constants';
import Page from 'mk2/pages/Page';
import React from 'react';

export interface FormPageStateProps {
    currentFormPage: FormPageType;
    mobile: boolean;
}

export interface FormPageDispatchProps {
    onOpenFormPage(formPage: FormPageType);
    onCloseFormPage();
    onCancelFormPage();
}

export default abstract class FormPage<
        TOwnProps,
        TStateProps extends FormPageStateProps,
        TDispatchProps extends FormPageDispatchProps,
        TMergedProps = TOwnProps & TStateProps & TDispatchProps
    >
    extends Page<TOwnProps, TStateProps, TDispatchProps> {

    public hasHeaderBackButton(props/*: TMergedProps */): boolean {
        return true;
    }

    public getHeaderLeft(props/*: TMergedProps */): React.ReactNode {
        const { currentFormPage, onCancelFormPage } = props;

        const onCancelFormPageWithQuestion = () => {
            onCancelFormPage();
        };

        return currentFormPage === FormPageType.Main ||
            currentFormPage === FormPageType.SignupPhotoUpload ||
            currentFormPage === FormPageType.SignupPhoneVerification ||
            currentFormPage === FormPageType.SignupTokenValidation
            ? super.getHeaderLeft(props)
            : (
                <Btn
                    type={BtnType.BlueTextLight}
                    label={CANCEL}
                    onClick={onCancelFormPageWithQuestion}
                />
            );
    }

    public getHeaderRight(props/*: TMergedProps */): React.ReactNode {
        const { currentFormPage, onCloseFormPage } = props;

        switch (currentFormPage) {
            case FormPageType.Main:
                return (
                    <>
                        {this.getHeaderAdditionalButtons(props)}
                        &ensp;
                        {this.getSubmitButton(props)}
                    </>
                );
            case FormPageType.AnonymousModeExplanation:
            case FormPageType.SelectTopicCategory:
                return null;
            default:
                return (
                    <Btn
                        label={CONFIRM}
                        onClick={onCloseFormPage}
                    />
                );
        }
    }

    public getHeaderAdditionalButtons(props: TMergedProps): React.ReactNode {
        return null;
    }

    public getFooter(props/*: TMergedProps */): React.ReactNode {
        const { currentFormPage, onCloseFormPage, mobile } = props;

        switch (currentFormPage) {
            case FormPageType.Main:
                return !mobile && this.getSubmitButton(props);
            case FormPageType.AnonymousModeExplanation:
            case FormPageType.ChangeGroupCover:
            case FormPageType.ChangeTopicCover:
            case FormPageType.SelectTopicCategory:
                return null;
            default:
                return !mobile && (
                    <Btn
                        label={CONFIRM}
                        onClick={onCloseFormPage}
                    />
                );
        }
    }

    /**
     * Get submit button for header
     */
    public abstract getSubmitButton(props: TMergedProps): React.ReactNode;
}
